import React from "react";
import { EditarFrete } from "./EditarFrete";
import { Frete } from "../AbaFrete";
import globalMU from "../../../../../globalMU";
import microuniversoApi from "../../../../api/microuniversoApi";
import { renderizarComponentReact } from "../../../renderizarOuRemoverComponentReact";
import { TelaEntregaContainer } from "../../TelaEntregaContainer";
import { tratamentoErroPadrao } from "../../../../use-cases";
import { IOrcamento } from "../../../../types/IOrcamento";
import { useAppSelector } from "../../../../redux/hooks";
import { Breadcrumb2Container } from "../../../breadcrumb2/Breadcrumb2Container";
import store from "app/redux/store/store";
import { gravarTelasAlteradasSalvaAction } from "app/redux/telaOrcamentoAlteradaNaoSalvaSlice";

export type EditarFreteContainerProps = {
  frete: Frete
}

export const EditarFreteContainer = (props: EditarFreteContainerProps) => {
  const orcamento: IOrcamento = useAppSelector((store) => store.orcamento)
  const aplicar = async (dados: Frete) => {
    try {
      globalMU.blockUI({ tryPassiveLoading: true })
      const response = await microuniversoApi.Orcamento.definirFreteCarga(orcamento.IdentificadorOrcamento, dados)
      if (!("Error" in response)) {
        globalMU.showSuccessMessage('Frete alterado com sucesso.')
        store.dispatch(gravarTelasAlteradasSalvaAction("telaEntrega_frete"))
        renderizarComponentReact(
          <TelaEntregaContainer telaDefault="Frete" />,
          "conteudo-pagina",
          true
        )
      }
    }
    catch (e) {
      tratamentoErroPadrao(e)
    } finally {
      globalMU.unblockUI()
    }
  }
  return <>
    <Breadcrumb2Container
      passos={["Entrega", "Editar Frete"]}
      id="breadcrumb-tela-frete"
      exibirBotaoLimpar={false}
      exibirBotaoVoltar
      onBotaoVoltarClicado={() => renderizarComponentReact(
        <TelaEntregaContainer telaDefault="Frete" />,
        "conteudo-pagina",
        true
      )}
      onPassoSelecionado={(passo) => {
        if (passo === "Entrega") {
          renderizarComponentReact(
            <TelaEntregaContainer telaDefault="Frete" />,
            "conteudo-pagina",
            true
          )
        }
      }}
    />
    <EditarFrete
        somenteLeitura={orcamento.SomenteLeitura}
        frete={props.frete}
        onAplicarFrete={aplicar}
    />
  </>
};
